// eslint-disable-next-line no-shadow
enum PasswordRecoveryStrategy {
  EMAIL,
  WHATSAPP,
  FACE,
}

export default PasswordRecoveryStrategy;
